// Радио кнопка с кастомным внешним видом
// т.к. оригинальный input[type='radio'] скрыт,
// то в тестах кликать нужно на label, а не на input

const template = /* html */`
    <label class="base-radio-btn">
        <input
            class="original-radio-btn"
            hidden
            type="radio"
            :name="name"
            :value="value"
            @change="$emit('update:modelValue', $event.target.value)"
        >
        <div class="custom-radio-btn" />
        <slot></slot>
    </label>
`;

export default {
    props: {
        value: { type: [String, Number] },
        modelValue: { type: [String, Number] },
        name: { type: String },
    },
    emits: ["update:modelValue"],
    template,
};
